import { useFormat } from '@ideavivat/vivat-2';

// eslint-disable-next-line
const toCurrency = (string: string | number) => parseFloat(string as string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    distanceType: {
      name: 'ระยะทาง',
      width: '8rem',
    },
    createdAt: {
      name: 'สร้างเมื่อ',
      width: '12rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
    },
    uniqueId: {
      name: 'เลขที่​ DN',
      width: '1fr',
    },
    distanceTravelled: {
      name: 'ระยะทาง (กม.)',
      width: '7rem',
      class: 'text-right',
      filter: (val: string) => toCurrency(val),
    },
    type: {
      name: 'ประเภท',
      width: '6rem',
    },
    vehicle: {
      name: 'รถขนส่ง',
      width: '16rem',
    },
    fuelCost: {
      name: 'ค่าน้ำมัน',
      width: '6rem',
    },
    tollFee: {
      name: 'ค่าทางด่วน (บาท)',
      width: '8rem',
    },
    rate: {
      name: 'อัตราเผาผลาญน้ำมัน (กม/ลิตร)',
      width: '16rem',
    },
    createdBy: {
      name: 'ผู้จัดรถ',
      width: '8rem',
    },
  },
  sortable: [
    'createdTime',
    'uniqueId',
    'distance',
    'type',
    'vehicle',
    // 'fuelCost',
    // 'tollFee',
    // 'rate',
    'createdBy',
  ],
};
